/**
 * Constantes del Portal Cliente (sin tenant fijo).
 *
 * El local se resuelve en runtime: URL → slug → locales → local.id.
 */

export const MENUEE_LOGO_FALLBACK = `${process.env.PUBLIC_URL || ""}/menuee-logo.png`;
